import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ErrorBoundaryService {
  public hasError = signal(false);

  triggerError() {
    this.hasError.set(true);
  }
}
